import { Skeleton } from './Skeleton';
import styles from './DashboardSkeleton.module.css';

// One KPI-card placeholder, matching the rounded stat cards at the top.
function KpiCardSkeleton() {
  return (
    <div className={styles.kpiCard}>
      <div className={styles.kpiTop}>
        <Skeleton width={110} height={12} />
        <Skeleton width={28} height={28} radius={8} />
      </div>
      <Skeleton width={70} height={30} style={{ marginTop: 16 }} />
      <Skeleton width={130} height={10} style={{ marginTop: 12 }} />
    </div>
  );
}

// One large chart/table card placeholder.
function CardSkeleton() {
  return (
    <div className={styles.card}>
      <div className={styles.cardTop}>
        <Skeleton width={170} height={16} />
        <Skeleton width={120} height={28} radius={8} />
      </div>
      <Skeleton height={220} radius={10} style={{ marginTop: 18 }} />
    </div>
  );
}

// Full dashboard skeleton: KPI row + two chart cards, shown while the initial
// store list / data is loading. Mirrors the real dashboard layout.
export default function DashboardSkeleton() {
  return (
    <div className={styles.wrap}>
      <div className={styles.kpiGrid}>
        {Array.from({ length: 4 }).map((_, i) => <KpiCardSkeleton key={i} />)}
      </div>

      <Skeleton width={150} height={18} style={{ marginTop: 28, marginBottom: 4 }} />
      <Skeleton width={220} height={12} style={{ marginBottom: 18 }} />

      <div className={styles.cardGrid}>
        <CardSkeleton />
        <CardSkeleton />
      </div>
    </div>
  );
}
